<template>
  <v-timeline-item
    color="error"
    small>
    <div class="title pt-3"></div>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'NoItemWhenExpected',
};
</script>

<style scoped>

</style>
